import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import Header from '~/components/layout/Header';
import NavigationCard from '~/components/pages/MyAccount/NavigationCard';
import SideBar from '~/components/layout/Sidebar';
import valegasicon from '~/assets/images/vale-gas.svg';
import HeaderMobile from '~/components/layout/HeaderOld';
import OpenChatBot from '~/components/layout/Chatbot';
import back from "~/assets/images/arrow.svg";

import { verifyRoles } from '~/utils/functions/verifyRoles';
import {
  Container,
  Content,
  HeaderContainer,
  HeaderMobileContainer,
  NavigationContainer,
  PageContainer,
  DivisionCards,
  DivisionCardsMobile,
  Left,
  ValeIcon,
  PageTitle,
  BackIcon
} from './styles';

export default function GasVoucherLinks() {
  const history = useHistory();
  const stores = useSelector(state => state.economicGroupReducer.stores);
  const roles = useSelector(state => state.rolesReducer.roles);
  const classificationReducer = useSelector((state) => state.classificationReducer);

  return (
    <PageContainer>
      <SideBar
        menuSelected={'Minha Conta'}
        hasPendenciOn={classificationReducer.pendenciesOn}
      >
        <Container>
          <Content>
            <HeaderContainer>
              <Header stores={stores} />
            </HeaderContainer>
            <HeaderMobileContainer>
              <HeaderMobile />
            </HeaderMobileContainer>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <Left>
                  <ValeIcon src={valegasicon} alt="Ícone do vale gás" />
                  <PageTitle>Vale Gás</PageTitle>
                </Left>
                <BackIcon>
                  <img
                    src={back}
                    alt="Ícone para voltar"
                    onClick={() => {
                      history.push('/minha-conta');
                    }}
                  />
                </BackIcon>
              </div>
                {/* <ValeIcon src={valegasicon} alt="Ícone do vale gás" />
                <PageTitle>Vale Gás</PageTitle> */}
              <NavigationContainer roles={roles} verifyRoles={verifyRoles}>
                <DivisionCards>
                  <NavigationCard
                    path="/valegas/validar"
                    title="Validar Vale Gás"
                    icon="check-icon.png"
                    bigCard
                  />
                  <NavigationCard
                    path="/valegas/relatorio"
                    title="Relatório Meus Vales"
                    icon="clipboard.png"
                    bigCard
                  />
                </DivisionCards>
                <DivisionCardsMobile>
                  <NavigationCard
                    path="/valegas/validar"
                    title="Validar Vale Gás"
                    icon="check-icon.png"
                  />
                  <NavigationCard
                    path="/valegas/relatorio"
                    title="Relatório Meus Vales"
                    icon="clipboard.png"
                  />
                </DivisionCardsMobile>
              </NavigationContainer>
          </Content>
        </Container>
      </SideBar>
      <OpenChatBot />
    </PageContainer>
  );
}
